import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SubsidyDossier } from './subsidy-dossier.model';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class SubsidyDossiersStore {
	private _dossiers$: BehaviorSubject<SubsidyDossier[]> = new BehaviorSubject<SubsidyDossier[]>([]);
	private _paymentRequestDossier$: BehaviorSubject<SubsidyDossier | null> = new BehaviorSubject<SubsidyDossier | null>(null);

	get dossiers$(): Observable<SubsidyDossier[]> {
		return this._dossiers$.asObservable();
	}

	get paymentRequestDossier$(): Observable<SubsidyDossier | null> {
		return this._paymentRequestDossier$.asObservable();
	}

	getDossier(id: number): Observable<SubsidyDossier | null> {
		return this._dossiers$.pipe(
			map((dossiers) => {
				return dossiers.find((d: any) => d.id === id) || null;
			})
		);
	}

	updateDossier(id: number, dossier: SubsidyDossier, isPaymentRequestDossier: boolean = false) {
		const dossiers = [...this._dossiers$.value];
		const index = dossiers.findIndex((s) => s.id === id);

		if (index >= 0) {
			dossier.baseProduct = dossiers[index].baseProduct;
			dossiers[index] = dossier;
		} else {
			dossiers.push(dossier);
		}

		this.setDossiers(dossiers);

		if (isPaymentRequestDossier) {
			this.setPaymentRequestDossier(dossier);
		}
	}

	setDossiers(dossiers: SubsidyDossier[]) {
		this._dossiers$.next(dossiers);
	}

	setPaymentRequestDossier(dossier: SubsidyDossier | null) {
		this._paymentRequestDossier$.next(dossier);
	}
}
